<template>
  <div class="container-fluid main">
    <!-- head component -->
    <div class="head-program text-center">
      <h1>Our Program</h1>
      <p class="text-muted mt-3">
        Ikuti Bootcamp untuk meningkatkan<br />
        skill dan bangun portofoliomu
      </p>
      <router-link to="/event">
        <button class="btnProgram">All Program</button>
      </router-link>
    </div>
    <!-- body component -->
    <div class="container mt-5">
      <div class="row">
        <!-- card 1 -->
        <div class="col mb-5">
          <div class="card rounded-5">
            <img
              class="card-img-top"
              src="../assets/program_1.png"
              alt="program 1"
            />
            <!-- valuation -->
            <div class="card-between mt-3">
              5.0
              <span class="align-items-center mb-2">
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
              </span>
            </div>
            <div class="card-body">
              <h5 class="card-title fw-bold">Bootcamp Intelligo Batch 3</h5>
              <p class="card-text">Rp.1.150.000,00</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1"
                  />
                  20 session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1"
                  />
                  120 peserta</span
                >
              </div>
              <button
                type="button"
                class="btn rounded-pill w-100 my-4 button-register-course"
              >
                Daftar Sekarang
              </button>
            </div>
          </div>
        </div>
        <!-- card 2 -->
        <div class="col mb-5">
          <div class="card rounded-5">
            <img
              class="card-img-top"
              src="../assets/program_2.png"
              alt="program 2"
            />
            <!-- valuation -->
            <div class="card-between mt-3">
              5.0
              <span class="align-items-center mb-2">
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
              </span>
            </div>
            <div class="card-body">
              <h5 class="card-title fw-bold">Bootcamp Intelligo Batch 4</h5>
              <p class="card-text">Rp.1.150.000,00</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1"
                  />
                  20 session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1"
                  />
                  120 peserta</span
                >
              </div>
              <button
                type="button"
                class="btn rounded-pill w-100 my-4 button-register-course"
              >
                Daftar Sekarang
              </button>
            </div>
          </div>
        </div>
        <!-- card 3 -->
        <div class="col mb-5">
          <div class="card rounded-5">
            <img
              class="card-img-top"
              src="../assets/program_1.png"
              alt="program 3"
            />
            <!-- valuation -->
            <div class="card-between mt-3">
              5.0
              <span class="align-items-center mb-2">
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
              </span>
            </div>
            <div class="card-body">
              <h5 class="card-title fw-bold">Bootcamp Intelligo Batch 5</h5>
              <p class="card-text">Rp.1.150.000,00</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1"
                  />
                  20 session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1"
                  />
                  120 peserta</span
                >
              </div>
              <button
                type="button"
                class="btn rounded-pill w-100 my-4 button-register-course"
              >
                Daftar Sekarang
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurProgram",
};
</script>

<style scoped>
.btnProgram {
  width: 159px;
  height: 44px;
  border-radius: 100px;
  background: #023047;
  border-radius: #023047;
  font-size: 16px;
  color: #fff;
  margin: 50px 0;
}
.btnProgram:hover {
  background-color: #f74d00;
  color: #fff;
  border: none;
}
.main {
  padding-top: 100px;
  padding-bottom: 100px;
}

.head-program > h1 {
  font-size: 32px !important;
  font-weight: 600;
  color: #023047;
}
.card-between {
  font-weight: 700;
  font-size: 1.25rem;
  margin-left: 15px;
}
.card-between img {
  margin-left: 10px;
}
.card-text {
  color: #ff865d;
}
.button-register-course {
  background: #023047;
  color: white;
}

@media only screen and (max-width: 500px) {
  .card {
    margin-left: 7%;
    width: 85%;
  }
  .card-body h5 {
    font-size: 14px;
  }
  .card-body span {
    font-size: 12px;
  }
  .card-between {
    font-size: 14px;
    margin-left: 15px;
  }
  .card-between img {
    width: 16px;
    margin-left: 3px;
  }
}
</style>
